import { productService } from '../_services';
import { router } from '../_helpers';

const localproducts = JSON.parse(localStorage.getItem('products'));
const initialState = localproducts
    ? { all: localproducts }
    : { all: {} };
    
export const products = {
    namespaced: true,
    state: {
        all: {},
        //one: {},
        saved: {},
        images: {},
    },
    actions: {
            
        getAll({ commit }) {
            commit('getAllRequest');

            productService.getAll()
                .then(
                    products => commit('getAllSuccess', products),
                    error => commit('getAllFailure', error)
                );
        },
        
        save({ dispatch, commit }, { id, articlenumber, attributes }) {
            commit('saveRequest');

            return productService.save( id, articlenumber, attributes )
               .then(
                    product => {
                        commit('saveSuccess', product );
                        //resolve( product )
                        //router.push('/thankyou');
                        return product
                    },
                    error => {
                        commit('saveError', error);
                        dispatch('alert/error', error, { root: true });
                    }
                );
        },
        
        uploadImages({ dispatch, commit }, { selectedFiles, articlenumber }) {
            //console.log( selectedFiles );
            commit('uploadImagesRequest');
            return productService.uploadImages( selectedFiles, articlenumber )
        }
        
    },
    mutations: {

        uploadImagesRequest(state){
            state.images = { uploading: true };
        },

        saveRequest(state){
            state.saved = { loading: true };
        },
        saveSuccess(state, product){
            state.saved = product ;
        },
        saveError(state, error ){
            state.saved = { error };
        },


        getAllRequest(state) {
            state.all = [] //{ loading: true };
        },
        getAllSuccess(state, products) {
            state.all = products;
//            console.log( state.all )

        },
        getAllFailure(state, error) {
            state.all = { error };
        }


    }
    
}